export const COLORS = {
  bg: '#0a0612',
  panel: '#120a19',
  primary: '#AD34FE',
  primaryDark: '#7b1fd4',
  accent: '#34ADFE',
  text: '#f5f0fa',
  textMuted: 'rgba(255,255,255,0.45)',
  textFaint: 'rgba(255,255,255,0.25)',
  border: 'rgba(173,52,254,0.2)',
  borderSoft: 'rgba(255,255,255,0.06)',
}

export const CARD_STYLE = {
  background: 'rgba(26, 14, 36, 0.7)',
  border: '1px solid rgba(173, 52, 254, 0.18)',
  backdropFilter: 'blur(32px)',
  boxShadow: '0 32px 64px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.04) inset',
}

export const SOFT_CARD_STYLE = {
  background: 'rgba(26, 14, 36, 0.5)',
  border: '1px solid rgba(255,255,255,0.06)',
  backdropFilter: 'blur(20px)',
}

export const PRIMARY_BTN_STYLE = {
  background: 'linear-gradient(135deg, #AD34FE 0%, #7b1fd4 100%)',
  color: '#fff',
  boxShadow: '0 0 32px rgba(173,52,254,0.35), 0 4px 16px rgba(0,0,0,0.3)',
}

export const GHOST_BTN_STYLE = {
  background: 'rgba(255,255,255,0.03)',
  border: '1px solid rgba(255,255,255,0.08)',
  color: 'rgba(255,255,255,0.65)',
}

export const INPUT_CLASS =
  'h-12 w-full rounded-xl px-4 text-sm outline-none transition-all duration-200 placeholder:text-white/20 focus:ring-2 focus:ring-[#AD34FE]/40'

export const INPUT_STYLE = {
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  color: '#f5f0fa',
}

export const STEPS = [
  {
    id: 'client',
    title: 'Cliente',
    optional: false,
    short: 'Cliente',
  },
  {
    id: 'agent',
    title: 'Agente',
    optional: false,
    short: 'Agente',
  },
  {
    id: 'setup',
    title: 'Preparar',
    optional: true,
    short: 'Preparar',
  },
  {
    id: 'finish',
    title: 'Concluir',
    optional: false,
    short: 'Concluir',
  },
]

export const ONBOARDING_SEEN_KEY = 'verboo_onboarding_seen'
export const ONBOARDING_STATE_KEY = 'verboo_onboarding_state'

export const DEFAULT_SETUP_PROGRESS = {
  visited: false,
  skipped: false,
  knowledgeCount: 0,
  templateIds: [],
}

function normalizeSetupProgress(progress) {
  return {
    ...DEFAULT_SETUP_PROGRESS,
    ...(progress || {}),
    knowledgeCount: Number(progress?.knowledgeCount) || 0,
    templateIds: Array.isArray(progress?.templateIds) ? progress.templateIds : [],
  }
}

export function loadOnboardingState() {
  try {
    const raw = localStorage.getItem(ONBOARDING_STATE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)

    // Migration: if state lacks createdPlatform, it's from the old flow — reset
    if (!parsed.createdPlatform && parsed.currentStep > 0) {
      clearOnboardingState()
      return null
    }

    return {
      currentStep: Number.isInteger(parsed.currentStep) ? parsed.currentStep : 0,
      mode: parsed.mode === 'agent' ? 'agent' : 'client',
      createdPlatform: parsed.createdPlatform ?? null,
      createdAssistant: parsed.createdAssistant ?? null,
      completedSteps: new Set(Array.isArray(parsed.completedSteps) ? parsed.completedSteps : []),
      integrationStatus: parsed.integrationStatus ?? { channel: false },
      setupProgress: normalizeSetupProgress(parsed.setupProgress),
    }
  } catch {
    return null
  }
}

export function saveOnboardingState(state) {
  try {
    const payload = {
      currentStep: state.currentStep,
      mode: state.mode,
      createdPlatform: state.createdPlatform,
      createdAssistant: state.createdAssistant,
      completedSteps: Array.from(state.completedSteps || []),
      integrationStatus: state.integrationStatus,
      setupProgress: normalizeSetupProgress(state.setupProgress),
    }
    localStorage.setItem(ONBOARDING_STATE_KEY, JSON.stringify(payload))
  } catch {
    /* quota / private mode — ignore */
  }
}

export function clearOnboardingState() {
  try {
    localStorage.removeItem(ONBOARDING_STATE_KEY)
  } catch {
    /* ignore */
  }
}
